import { EmergencyNotificationSmsConfigurationContactPersonValue } from '../EmergencyNotificationSmsConfigurationContactPersonsField.types';

export const createEmptyEmergencyNotificationSmsConfigurationContactPersonValue = (): EmergencyNotificationSmsConfigurationContactPersonValue => ({
   name: null,
   phoneNumber: null,
});
